import { Star, Trash2, Store } from "lucide-react";
import { Link } from "react-router-dom";
import { Avatar } from "@/components/Avatar";
import { HelpfulButton } from "@/components/HelpfulButton";
import { ReviewPhotos, PhotoStrip } from "@/components/ReviewPhotos";
import { Button } from "@/components/ui/button";
import { CommentThread } from "@/components/CommentThread";

export function Stars({ value, onChange, size = "h-5 w-5" }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!onChange} data-testid={onChange ? `review-star-${n}` : undefined}
          onClick={() => onChange?.(n)} className={onChange ? "transition-transform hover:scale-110" : "cursor-default"}>
          <Star className={`${size} ${n <= value ? "fill-[#FFB800] text-[#FFB800]" : "text-slate-600"}`} />
        </button>
      ))}
    </div>
  );
}

export function ReviewForm({ mine, rating, setRating, text, setText, photos, setPhotos, busy, submit }) {
  return (
    <div className="rounded-2xl bg-[#0B0F19] border border-[#26334D] p-3 space-y-2">
      <p className="text-sm text-slate-300">{mine ? "Update your review" : "Been here? Help other travelers"}</p>
      <Stars value={rating} onChange={setRating} />
      <textarea data-testid="review-text-input" value={text} onChange={(e) => setText(e.target.value)} maxLength={1000} rows={2}
        placeholder="What should other travelers know?" className="w-full bg-transparent border border-[#26334D] rounded-xl p-2 text-sm outline-none focus:border-[#FFB800]" />
      <ReviewPhotos photos={photos} onChange={setPhotos} />
      <Button data-testid="review-submit" disabled={busy} onClick={submit} size="sm" className="rounded-full bg-[#FFB800] hover:bg-[#E6A600] text-[#0B0F19] font-semibold">
        {busy ? "Saving…" : mine ? "Update review" : "Post review"}
      </Button>
    </div>
  );
}

export function ReviewItem({ r, remove, load }) {
  return (
    <div data-testid={`review-item-${r.id}`} className="border-b border-[#26334D] pb-3 last:border-0">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2"><Avatar url={r.author_avatar} name={r.user_name} size="h-7 w-7" testid={`review-avatar-${r.id}`} /><Stars value={r.rating} size="h-3.5 w-3.5" /><Link to={`/traveler/${r.author_id}`} data-testid={`review-author-${r.id}`} className="text-sm font-semibold hover:text-[#FFB800]">{r.user_name}</Link></div>
        <div className="flex items-center gap-2 text-xs text-slate-500">
          {new Date(r.updated_at).toLocaleDateString()}
          {r.mine && <button data-testid={`review-delete-${r.id}`} onClick={() => remove(r.id)}><Trash2 className="h-3.5 w-3.5 text-[#FF7A7A]" /></button>}
        </div>
      </div>
      {r.text && <p className="text-sm text-slate-300 mt-1">{r.text}</p>}
      <PhotoStrip photos={r.photos} rid={r.id} />
      <HelpfulButton review={r} onVoted={load} />
      {r.reply?.text && (
        <div data-testid={`review-reply-${r.id}`} className="mt-2 ml-3 pl-3 border-l-2 border-[#FFB800] text-sm">
          <p className="text-xs font-semibold text-[#FFB800] flex items-center gap-1"><Store className="h-3 w-3" /> Reply from the business</p>
          <p className="text-slate-300">{r.reply.text}</p>
        </div>
      )}
      <CommentThread kind="review" target={r.id} count={r.comment_count} />
    </div>
  );
}
